import { render, staticRenderFns } from "./ListCopy.vue?vue&type=template&id=dffb0ca2&scoped=true"
import script from "./ListCopy.vue?vue&type=script&lang=js"
export * from "./ListCopy.vue?vue&type=script&lang=js"
import style0 from "./ListCopy.vue?vue&type=style&index=0&id=dffb0ca2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffb0ca2",
  null
  
)

export default component.exports